 
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuItemDetailsDocument = gql`
    query GetMenuItemDetails($menuId: Int, $dishId: Int, $categoryId: Int, $locale: String, $branchId: Int!, $typeMenu: MenuTypeType) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    branch {
      currencyCode
    }
    items(id: $dishId, categoryId: $categoryId) {
      id
      name(locale: $locale)
      nameOrigin
      favicon
      categories(id: $categoryId) {
        favicon {
          path
        }
      }
      description(locale: $locale)
      descriptionOrigin
      composition(locale: $locale)
      compositionOrigin
      portions {
        id
        name(locale: $locale)
        nameOrigin
        price
        volume
      }
      unit {
        id
        name
      }
      cookingTime
      isLongCookingTime
      markers {
        id
        name
        favicon
      }
      allergens {
        id
        name
        favicon
      }
      supplements(isDeleted: false) {
        id
        groupName(locale: $locale)
        groupNameOrigin
        price
        isRequireOnOrder
        maxCountOnOrder
        numberOfOption
        options {
          id
          name(locale: $locale)
          nameOrigin
          price
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemDetailsQuery__
 *
 * To run a query within a React component, call `useGetMenuItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemDetailsQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      dishId: // value for 'dishId'
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *   },
 * });
 */
export function useGetMenuItemDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables> & ({ variables: GetMenuItemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>(GetMenuItemDetailsDocument, options);
      }
export function useGetMenuItemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>(GetMenuItemDetailsDocument, options);
        }
export function useGetMenuItemDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>(GetMenuItemDetailsDocument, options);
        }
export type GetMenuItemDetailsQueryHookResult = ReturnType<typeof useGetMenuItemDetailsQuery>;
export type GetMenuItemDetailsLazyQueryHookResult = ReturnType<typeof useGetMenuItemDetailsLazyQuery>;
export type GetMenuItemDetailsSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemDetailsSuspenseQuery>;
export type GetMenuItemDetailsQueryResult = Apollo.QueryResult<GetMenuItemDetailsQuery, GetMenuItemDetailsQueryVariables>;
export type GetMenuItemDetailsQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  dishId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
}>;


export type GetMenuItemDetailsQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', branch: { __typename?: 'BranchProxy', currencyCode: string }, items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, favicon?: string | null, description?: string | null, descriptionOrigin?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, isLongCookingTime: boolean, categories?: Array<{ __typename?: 'MenuCategoryProxy', favicon?: { __typename?: 'MenuCategoryIconProxy', path?: string | null } | null }> | null, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, price: number, volume: number }> | null, unit: { __typename?: 'UnitProxy', id: number, name: string }, markers?: Array<{ __typename?: 'MenuMarkerProxy', id: number, name: string, favicon?: string | null }> | null, allergens?: Array<{ __typename?: 'MenuAllergenProxy', id: number, name: string, favicon?: string | null }> | null, supplements?: Array<{ __typename?: 'MenuSupplementProxy', id: number, groupName?: string | null, groupNameOrigin?: string | null, price?: number | null, isRequireOnOrder?: boolean | null, maxCountOnOrder?: number | null, numberOfOption?: number | null, options?: Array<{ __typename?: 'MenuSupplementProxy', id: number, name?: string | null, nameOrigin?: string | null, price?: number | null }> | null }> | null }> | null } };
